"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const js_fetch_api_1 = require("@giphy/js-fetch-api");
const js_util_1 = require("@giphy/js-util");
const css_1 = require("@emotion/css");
const preact_1 = require("preact");
const throttle_debounce_1 = require("throttle-debounce");
const observer_1 = __importDefault(require("../util/observer"));
const gif_1 = __importDefault(require("./gif"));
const pingback_context_manager_1 = __importDefault(require("./pingback-context-manager"));
const carouselCss = (0, css_1.css) `
    -webkit-overflow-scrolling: touch;
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    position: relative;
`;
const carouselItemCss = (0, css_1.css) `
    display: inline-block;
    list-style: none;
    /* make sure gifs are fully visible with a scrollbar */
    margin-bottom: 1px;
    &:first-of-type {
        margin-left: 0;
    }
`;
const loaderContainerCss = (0, css_1.css) `
    display: inline-block;
`;
const loaderCss = (0, css_1.css) `
    width: 30px;
    display: inline-block;
`;
const defaultProps = Object.freeze({ gutter: 6, user: {} });
const initialState = Object.freeze({
    isFetching: false,
    numberOfGifs: 0,
    gifs: [],
    isLoaderVisible: true,
    isDoneFetching: false,
});
class Carousel extends preact_1.Component {
    constructor() {
        super(...arguments);
        this.state = initialState;
        this.paginator = (0, js_fetch_api_1.gifPaginator)(this.props.fetchGifs);
        this.onLoaderVisible = (isVisible) => {
            this.setState({ isLoaderVisible: isVisible }, this.onFetch);
        };
        this.onFetch = (0, throttle_debounce_1.debounce)(100, () => __awaiter(this, void 0, void 0, function* () {
            const { isFetching, isLoaderVisible, gifs: existingGifs } = this.state;
            if (!isFetching && isLoaderVisible) {
                this.setState({ isFetching: true });
                let gifs;
                try {
                    gifs = yield this.paginator();
                }
                catch (error) {
                    this.setState({ isFetching: false });
                }
                if (gifs) {
                    if (existingGifs.length === gifs.length) {
                        this.setState({ isDoneFetching: true });
                    }
                    else {
                        this.setState({ gifs, isFetching: false });
                        const { onGifsFetched } = this.props;
                        if (onGifsFetched)
                            onGifsFetched(gifs);
                        this.onFetch();
                    }
                }
            }
        }));
    }
    componentDidMount() {
        this.onFetch();
    }
    render({ onGifVisible, onGifRightClick, gifHeight, gifWidth, gutter, className = Carousel.className, onGifClick, onGifHover, onGifKeyPress, onGifSeen, user, noResultsMessage, hideAttribution, noLink, tabIndex = 0, borderRadius, }, { gifs }) {
        const showLoader = gifs.length > 0;
        const marginCss = (0, css_1.css) `
            margin-left: ${gutter}px;
        `;
        const gifHeightCss = (0, css_1.css) `
            height: ${gifHeight}px;
        `;
        const containerCss = (0, css_1.cx)(className, carouselCss);
        const gifCss = (0, css_1.cx)(carouselItemCss, marginCss);
        return ((0, preact_1.h)(pingback_context_manager_1.default, { attributes: { layout_type: 'CAROUSEL' } },
            (0, preact_1.h)("div", { class: containerCss },
                gifs.map((gif) => {
                    return ((0, preact_1.h)(gif_1.default, { className: gifCss, gif: gif, key: gif.id, tabIndex: tabIndex, width: gifWidth || (0, js_util_1.getGifWidth)(gif, gifHeight), height: gifHeight, onGifClick: onGifClick, onGifHover: onGifHover, onGifKeyPress: onGifKeyPress, onGifSeen: onGifSeen, onGifVisible: onGifVisible, onGifRightClick: onGifRightClick, user: user, hideAttribution: hideAttribution, noLink: noLink, borderRadius: borderRadius }));
                }),
                !showLoader && gifs.length === 0 && noResultsMessage,
                showLoader && ((0, preact_1.h)(observer_1.default, { className: loaderContainerCss, onVisibleChange: this.onLoaderVisible },
                    (0, preact_1.h)("div", { className: (0, css_1.cx)(loaderCss, gifHeightCss) }))))));
    }
}
Carousel.className = 'giphy-carousel';
Carousel.defaultProps = defaultProps;
exports.default = Carousel;
//# sourceMappingURL=carousel.js.map